import React, { useState, useCallback, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import axios from "axios";
import { useRouter } from "next/router";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { ENDPOINTS } from "@/config/endpoints";
import Image from "next/image";
import enIN from '@/locales/partner-program/enIN';
import esMX from '@/locales/partner-program/enMX';
import enUS from "@/locales/partner-program/enUS";

const schema = (t) => {
  const requiredMessage = t.FormData.requiredMessage;
    const emailMessage = t.FormData.emailMessage;
    const phoneMessage = t.FormData.phoneMessage;
    const phoneMessage2 = t.FormData.phoneMessage2

  return yup.object({
    Name: yup.string().required(requiredMessage),
    Email: yup
      .string()
      .required(requiredMessage)
      .email(emailMessage),
    Phone: yup
      .string()
      .required(requiredMessage)
      .matches(/^\d{10}$/, phoneMessage)
      .test(
        phoneMessage2,
        (value) => value && /^[4-9]\d{9}$/.test(value)
      ),
    Company: yup.string().required(requiredMessage),
  });
};

const PartnerProgramFormES = () => {
  const router = useRouter();
  const { locale } = router;
  const t = (locale === 'es-mx' && esMX) || (locale === 'en-us' && enUS) || (locale === 'en-in' && enIN);
  const validationSchema = schema(t);
  const [campaignName, setCampaignName] = useState("US");
  const [countryCode, setCountryCode] = useState("+1");
  const [ThankyouRes, setThankyouRes] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [errMSG, setErrMSG] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { isValid, errors },
  } = useForm({
    mode: "all",
    resolver: yupResolver(validationSchema),
  });

  const handleCaptchaSubmit = useCallback(
    (values) => {
      if (!executeRecaptcha) {
        return false;
      }
      executeRecaptcha("enquiryFormSubmit").then((gReCaptchaToken) => {
        onFormSubmit({...values, campaignName,countryCode}, gReCaptchaToken);
      });
    },
    [executeRecaptcha,campaignName,countryCode]
  );

  useEffect(() => {
    if (locale === "en-us") {
      setCountryCode("+1");
      setCampaignName("US");
    } else if (locale === "es-mx") {
      setCountryCode("+52");
      setCampaignName("Mexico");
    }
  }, [locale]);

  async function onFormSubmit(values,gReCaptchaToken) {
    const body = {
      formType: "PartnerProgram",
      name: values.Name,
      email: values.Email,
      phoneNumber: values.Phone,
      company: values.Company,
      country: values.campaignName,
      countryCode: values.countryCode,
      sourceUrl: window.location.href,
    };
    let config = {
      method: "post",
      url: ENDPOINTS.PARTNER_PROGRAM,
      headers: {
        "Content-Type": "application/json",
        "g-recaptcha-response": gReCaptchaToken,
      },
      data: body,
    };

    try {
      const response = await axios(config);
      if (response.status == 200) {
        if(locale === 'en-us'){
          gtag('event', 'getPartnerUS', {
            'event_category': 'getPartnerUS',
            'event_label': 'Partner US'
        });
        }else if (locale === 'es-mx'){
        gtag('event', 'getPartnerMexico', {
          'event_category': 'getPartnerMexico',
          'event_label': 'Partner Mexico'
      });
     }
        setThankyouRes(true);
        setTimeout(() => {
          setThankyouRes(false);
          router.push("/thankyou-response");
        }, 3000);
      }
    } catch (err) {
      setErrMSG(true);
      console.log("error", err);
      setTimeout(() => {
        window.location.reload();
      }, 5000);
    }
  }

  return (
    <div className="sm:w-full my-14 sm:my-6 sm:px-3">
      <div className="bg-white sm:mt-2 shadow-icon-btn-shadow rounded-[8px] py-5 px-3 sm:px-[16px] lg:w-full lg:max-w-[370px] md:max-w-[370px] sm:w-[100%] ml-auto md:relative md:m-auto border-#FFFFFF">
        <Image
          src={t.FormData.imagePath}
          width={325}
          height={56}
          alt="Tenx Faster"
        />
        <form
          onSubmit={handleSubmit(handleCaptchaSubmit)}
          // onSubmit={handleSubmit(onFormSubmit)}
        >
          <div className="pt-5">
            <input
              name="Name"
              type="text"
              id="name"
              placeholder={t.FormData.name}
              className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
              {...register("Name")}
            />
            <p className="text-progressColor4 text-xs mt-[3px]">
              {errors.Name?.message}
            </p>
          </div>
          <div className="pt-2">
            <input
              {...register("Email")}
              id="email"
              type="email"
              placeholder={t.FormData.Email}
              className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
            />
            <p className="text-progressColor4 text-xs mt-[3px]">
              {errors.Email?.message}
            </p>
          </div>
          <div className="pt-2">
            <input
              placeholder={t.FormData.Mobile}
              className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
              {...register("Phone")}
              id="tel"
              type="tel"
              maxLength="10"
            />
            <p className="text-progressColor4 text-xs">
              {errors.Phone?.message}
            </p>
            </div>
          <div className="pt-2">
            <input
              name="Company"
              type="text"
              id="company"
              placeholder={t.FormData.Company}
              className="block w-full appearance-none rounded-md border border-bordercolor px-3 py-1 placeholder-gray-400 text-sm font-normal"
              {...register("Company")}
            />
            <p className="text-progressColor4 text-xs mt-[3px]">
              {errors.Company?.message}
            </p>
          </div>
          <div className="mt-4">
            <button
              className="py-1 px-3 rounded-md text-white text-lg font-normal w-full bg-gradient-to-r from-[#022B5C] to-[#0363C4] shadow-lg transition-all duration-300 hover:from-[#0363C4] hover:to-[#022B5C]"
              type="submit"
            >
              {t.FormData.Submitbtn}
            </button>
          </div>
        </form>
        {ThankyouRes ? (
          <>
            <div className="text-green text-center">
              <p className="text-sm font-medium mt-3">
               {t.FormData.ThankYou}
              </p>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default PartnerProgramFormES;
